<template>
    <form
        :action="autocompleteUrl"
        v-on:submit.prevent="search"
        method="get"
        accept-charset="utf-8"
        class="c-form"
    >
        <i class="ico ico-search"></i>

        <div class="c-form__item c-form__item--text">
            <input
                type="text"
                :id="'autocomplete-' + parseInt(Math.random() * 1000)"
                v-model="keyword"
                name="search"
                autocomplete="off"
                :placeholder="inputPlaceholder"
                @input="search"
                @focus="showForm"
                @keyup.enter="redirectToSearch"
                :class="{
                    'c-form__input': true,
                    'is-empty': !keyword,
                    'is-open': isOpen
                }"
                ref="searchInput"
            />
        </div>

        <a
            :href="searchUrl"
            class="c-btn c-btn--primary is-search"
            :class="{
                'is-loading': isLoading,
                'is-open': isOpen
            }"
        >
            {{ $t('Autocomplete.Header.search') }}
        </a>

        <button
            type="button"
            @click="hideForm"
            class="c-btn is-close"
            :class="{
                'is-loading': isLoading,
                'is-open': isOpen
            }"
        >
            <i aria-hidden="true" class="ico ico-close-thin"></i>
        </button>
    </form>
</template>

<script>
import RshopAutocompleteForm from "FrontendComponents/Autocomplete/Form/index.vue";

export default {
    extends: RshopAutocompleteForm,
    props: {
        isFormVisible: {
            type: Boolean,
            default: false,
        },
        isOpen: {
            type: Boolean,
            default: false,
        },
        inputPlaceholder: {
            type: String,
            required: true
        }
    },
    methods: {
        showForm() {
            this.$emit('show-form')
        },
        hideForm() {
            this.$emit('hide-form')
        },
        redirectToSearch() {
            window.location.href = this.searchUrl
        },
    },
    computed: {
        searchUrl() {
            return `/vyhladavanie${this.keyword ? `?search=${encodeURIComponent(this.keyword)}` : ''}`
        }
    },
    watch: {
        isFormVisible(value) {
            if (value) {
                this.$nextTick(() => {
                    this.$refs.searchInput.focus()
                })
            }
        }
    }
};
</script>
